import Vue from 'vue';
import Store from '@app/store';
export default Vue.extend({
    computed: {
        languages: function () {
            return Store.STATE.languages;
        },
        activeLanguage: function () {
            return Store.GETTERS.activeLanguage();
        },
    },
    methods: {
        classes: function (language, index) {
            var classes = [];
            this.activeLanguage.id == language.id && classes.push('active');
            this.languages[index + 1] && classes.push('border-right');
            return classes;
        }
    }
});
